import { AxiosError, AxiosResponse } from 'axios'
import { FetchProps } from '../Hooks/AuthFetch/AuthFetch'
import { FetchErrorCodes, StatusCodes } from '../Libs'

export interface E3dcFetchError {
  statusCode: StatusCodes
  errno?: FetchErrorCodes
  error: string
  /** used for optional information */
  message?: unknown
  attributes?: {
    error: string
    errno: FetchErrorCodes
    message: string
  }
}

export type AuthFetchWithResponse = <T>(props: FetchProps) => Promise<AxiosResponse<T>>
export type AuthFetchWithResult = <T>(props: FetchProps) => Promise<T>
export type AuthFetchError = AxiosError<E3dcFetchError>

export class ApiResult<T, E = unknown> {
  value: T | null
  hasErrors: boolean
  error: E | undefined
  constructor(value: T | null = null, hasErrors = false, error?: E) {
    this.value = value
    this.hasErrors = hasErrors
    this.error = error
  }
}
